import { PlayerSimple } from '@loquis/player';
import { IAdvertising, IPlayResponse } from '@loquis/shared';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { createStopPayload } from '../../core/helper/rest.helper';
import { getFormatted } from '../../core/helper/string.helper';
import { loquisPlay, loquisStop } from '../../core/rest/play.service';
import './playerWidget.style.scss';

export default function PlayerWidget(p: Props) {
  const audioRef = useRef<HTMLAudioElement>(null);
  const playedRef = useRef<true>();
  const [playResponseState, setPlayResponseState] = useState<IPlayResponse>();
  const [srcState, setSrcState] = useState<string>();
  const [advPlayTimeState, setAdvPlayTimeState] = useState<any>();
  const [countdownState, setCountdownState] = useState<any>();

  useEffect(() => {
    return () => {
      if (playedRef.current === true) {
        markStop();
      }
    };
  }, []);

  useEffect(() => {
    p.onPlayerInit(audioRef.current);
  }, [audioRef.current]);

  useEffect(() => {
    if (p.play === true) {
      loquisPlay(p.loquisId).then((data) => {
        setPlayResponseState(data);
        setSrcState(data.audio_hls || data.audio_mp3);
        if (data.adv) {
          p.onAdv(data.adv);
        }
      });
    }
  }, [p.play]);

  useEffect(() => {
    if (p.playAdv === true) {
      setSrcState(playResponseState.adv.audio_url);
    }
  }, [p.playAdv]);

  useEffect(() => {
    setCountdownState(playResponseState?.adv?.audio_length - advPlayTimeState);
  }, [advPlayTimeState]);

  const markStop = () => {
    loquisStop(p.loquisId, createStopPayload(audioRef.current.currentTime, p.localeId, audioRef.current.duration));
  };

  const openLoquisPage = (e: SyntheticEvent) => {
    if ((e.target as any).tagName !== 'AUDIO') {
      window.open('https://www.loquis.com/it/loquis/' + p.localeId, '_blank');
    }
  };

  const endedHandler = (e: any) => {
    p.onEnded(e);
    markStop();
  };

  const playHandler = (e: any) => {
    p.onPlay(e);
    playedRef.current = true;
  };

  const listenHandler = (e: any) => {
    setAdvPlayTimeState(Math.floor(e));
  };

  const advClickHandler = (e: any) => {
    window.open(playResponseState.adv.banner_link, '_blank');
  };

  return (
    <section className="PlayerWidgetComponent" onClick={openLoquisPage}>
      {!p.playAdv ? (
        <div className="metaInfo">
          <img className="metaInfo__picture" src={p.picture} alt={p.name} />
          <div style={{ textAlign: 'left' }}>
            <p className="metaInfo__title">{p.name}</p>
            <p className="metaInfo__channel">{p.channel}</p>
          </div>
        </div>
      ) : (
        <div
          className="metaInfo--adv"
          onClick={advClickHandler}
          style={{
            backgroundImage: `url('${playResponseState.adv.banner_url}')`,
          }}
        >
          <p className="countdown">{getFormatted(countdownState)}</p>
        </div>
      )}
      <div className="player" style={{ display: p.playAdv ? 'none' : 'initial' }}>
        <PlayerSimple
          controlsList="nodownload"
          autoPlay
          audioRef={(e: any) => (audioRef.current = e)}
          src={srcState}
          controls
          onLoad={p.onLoad}
          onPlay={playHandler}
          onPause={p.onPause}
          onEnded={endedHandler}
          onDurationChange={p.onDurationChange}
          onListen={listenHandler}
        />
      </div>
    </section>
  );
}

interface Props {
  loquisId: number;
  localeId: number;
  name: string;
  channel: string;
  picture: string;
  onPlay?: (e: SyntheticEvent) => void;
  onPause?: (e: SyntheticEvent) => void;
  onLoad?: (e: SyntheticEvent) => void;
  onDurationChange?: (e: any) => void;
  play?: boolean;
  playAdv?: boolean;
  onAdv?: (e: IAdvertising) => void;
  onEnded?: (e: SyntheticEvent) => void;
  onPlayerInit?: (arg: any) => void;
}
